export const getNextInvoiceAmount = (invoiceBaseAmount, invoiceFeeAmount) => {
  if (invoiceFeeAmount && invoiceBaseAmount) {
    return Number(invoiceFeeAmount) + Number(invoiceBaseAmount)
  }

  return 0
}
